const CartValidator = (function () {

  const _metafieldsIdentifiers = [
    { namespace: "custom", key: "min_quantity" },
    { namespace: "custom", key: "max_quantity" },
  ];

  return {
    validate
  }

  ////////////////////////////////////////////////////////////////////////////

  async function validate() {
    const cartItems = await _getCombinedCartItems();

    const variantMap = cartItems.reduce((acc, item) => {
      acc[item.variant_id] = { quantity: item.quantity };
      return acc;
    }, {});

    const variantIds = cartItems.map(item => item.variant_id);
    const metafields = await _getMetafieldsForVariants(variantIds);

    if (metafields === null) {
      return;
    }

    _repairMinMax(cartItems, metafields);
  }

  ////////////////////////////////////////////////////////////////////////////

  async function _getCombinedCartItems() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return _combineDuplicates(cart.items);
    } catch (error) {
      console.error('Failed to get cart items:', error);
      return [];
    }
}

  function _combineDuplicates(items) {
    return Object.values(
        items.reduce((acc, product) => {
            if (!acc[product.variant_id]) {
                acc[product.variant_id] = { ...product };
            } else {
                acc[product.variant_id].quantity += product.quantity;
            }
            return acc;
        }, {})
    );
  }

  async function _getMetafieldsForVariants(variantsIds) {
    const query = `
      query GetMetafields($ids: [ID!]!, $identifiers: [HasMetafieldsIdentifier!]!) {
        nodes(ids: $ids) {
          ... on ProductVariant {
            id
            title
            metafields(identifiers: $identifiers) {
              id
              namespace
              key
              value
            }
            product {
              id
              metafields(identifiers: $identifiers) {
                id
                namespace
                key
                value
              }
            }
          }
        }
      }
    `;

    const ids = [];
    for (const variantId of variantsIds) {
      ids.push(`gid://shopify/ProductVariant/${variantId}`);
    }

    const variables = { ids, identifiers: _metafieldsIdentifiers };
    const response = await fetch("https://boopbeauty.myshopify.com/api/2024-10/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": window._sfKey,
      },
      body: JSON.stringify({ query, variables }),
    });

    const { data, errors } = await response.json();

    if (errors || !data.nodes) {
      return null;
    }

    const result = {};
    for (const variant of data.nodes) {
      if (!variant) {
        continue;
      }

      const id = variant.id.replace('gid://shopify/ProductVariant/', '');
      const minmax = _mapMetafields(variant.metafields);

      result[id] = minmax;
    }

    return result;
  }

  function _mapMetafields(metafields) {
    const minQuantity = metafields.find(field => field?.key === "min_quantity")?.value;
    const maxQuantity = metafields.find(field => field?.key === "max_quantity")?.value;
    return {
      min: minQuantity ? parseInt(minQuantity) : null,
      max: maxQuantity ? parseInt(maxQuantity) : null,
    };
  }

  function _repairMinMax(cartItems, metafields) {
    let data = {};

    cartItems.forEach(item => {
        const variantId = item.variant_id;
        const cartQty = item.quantity;

      if (metafields[variantId]) {
        const min = metafields[variantId]?.min ?? null;
        const max = metafields[variantId]?.max ?? null;

        if (min && cartQty < min) {
          data[variantId] = min;
        } else if (max && cartQty > max) {
          data[variantId] = max;
        }
      }
    });

    ATCHandler.updateCartItem(data);
  }

})();

document.addEventListener('DOMContentLoaded', ()=>{
    CartValidator.validate();
})
